export interface AppPaginatedList<T> {
  items: T[];
  meta: {
    total: number;
    page: number;
    perPage: number;
  };
}

export function mapPaginatedResponse<T>(sdkResponse: {
  data: T[];
  meta: {total: number; page: number; perPage: number};
}): AppPaginatedList<T> {
  return {
    items: sdkResponse.data,
    meta: {
      total: sdkResponse.meta.total,
      page: sdkResponse.meta.page,
      perPage: sdkResponse.meta.perPage,
    },
  };
}
